module.exports = __webpack_public_path__ + "static/img/phone_selec.daf411b0.svg";